import React from 'react';

import { SuiContainer, SuiLabel } from '@splashthat/sui';

import {
    QUESTION_TEXT_LABEL,
    INPUT_TEXT_LABEL,
    HELPER_TEXT_LABEL,
    INPUT_BACKGROUND,
    INPUT_WORD_LABEL,
} from '../../../../constants/formStyleLabels';
import { COLLAPSIBLE_CONTENT, COLLAPSIBLE_SECTION } from '../../../../constants/reusableClassNames';

import { FORM_FIELDS_QA } from '../../../../utils/qaIdConstants';

import QuestionTextPanel from './QuestionTextPanel';
import InputTextPanel from './InputTextPanel';
import HelperTextPanel from './HelperTextPanel';
import InputBackgroundPanel from './InputBackgroundPanel';
import InputBorderPanel from './InputBorderPanel';

/** @var {Object} - section components and labels ordered. */
const SECTION_PANELS = [
    {
        panel: <QuestionTextPanel />,
        label: QUESTION_TEXT_LABEL,
        qaId: 'questionText',
    },
    {
        panel: <HelperTextPanel />,
        label: HELPER_TEXT_LABEL,
        qaId: 'helperText',
    },
    {
        panel: <InputTextPanel />,
        label: INPUT_TEXT_LABEL,
        qaId: 'inputText',
    },
    {
        panel: <InputBackgroundPanel />,
        label: INPUT_BACKGROUND,
        qaId: 'inputBackground',
    },
    {
        panel: <InputBorderPanel componentLabel={INPUT_WORD_LABEL} />,
        qaId: 'border',
    },
];

const FormStyleEditorFormFieldsPanel = () => (
    <SuiContainer className={COLLAPSIBLE_CONTENT} data-qa={`${FORM_FIELDS_QA}--panel`}>
        {SECTION_PANELS.map(({ panel, label, qaId }, index) => (
            <SuiContainer key={index} className={COLLAPSIBLE_SECTION} data-qa={`${FORM_FIELDS_QA}--section-${qaId}`}>
                {label && <SuiLabel text={label} data-qa={`${FORM_FIELDS_QA}--label`} />}
                {panel}
            </SuiContainer>
        ))}
    </SuiContainer>
);

export default FormStyleEditorFormFieldsPanel;
